"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaValidationError = exports.MaintenanceError = exports.ForbiddenError = exports.UnauthorizedError = exports.BadRequestError = exports.StatusError = void 0;
const types_1 = require("../types");
class StatusError extends Error {
    status;
    code;
    constructor(status = 500, code = 'unexpected', message = '') {
        super(message || `Status: ${status}. Code: ${code}`);
        this.name = 'StatusError';
        Error.captureStackTrace(this, StatusError);
        this.status = status || 500;
        this.code = code || '';
    }
    createResponse() {
        return new types_1.Response({ code: this.code, message: this.message }, { statusCode: this.status, headers: { 'Content-type': 'application/json' } });
    }
}
exports.StatusError = StatusError;
class BadRequestError extends StatusError {
    constructor(code, message) {
        super(400, code, message);
        this.name = 'BadRequestError';
        Error.captureStackTrace(this, BadRequestError);
    }
}
exports.BadRequestError = BadRequestError;
class UnauthorizedError extends StatusError {
    constructor(code, message) {
        super(401, code, message);
        this.name = 'UnauthorizedError';
        Error.captureStackTrace(this, UnauthorizedError);
    }
}
exports.UnauthorizedError = UnauthorizedError;
class ForbiddenError extends StatusError {
    constructor(code, message) {
        super(403, code, message);
        this.name = 'ForbiddenError';
        Error.captureStackTrace(this, ForbiddenError);
    }
}
exports.ForbiddenError = ForbiddenError;
class MaintenanceError extends StatusError {
    constructor() {
        super(503, 'maintenance_mode', 'The service is temporarily unavailable due to maintenance.');
        this.name = 'MaintenanceError';
    }
}
exports.MaintenanceError = MaintenanceError;
class SchemaValidationError extends StatusError {
    errors;
    constructor(errors) {
        const fields = errors.map(e => e.path).join(', ');
        super(400, 'schema_validation_error', `Invalid fields: ${fields}`);
        this.errors = errors;
        this.name = 'SchemaValidationError';
        Error.captureStackTrace(this, SchemaValidationError);
    }
    createResponse() {
        return new types_1.Response({ code: this.code, message: this.message, errors: this.errors }, { statusCode: 400, headers: { 'Content-type': 'application/json' } });
    }
}
exports.SchemaValidationError = SchemaValidationError;
